import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { url } from 'src/app/config/config';
import { map } from 'rxjs/operators';



@Injectable({
  providedIn: 'root'
})
export class ImageBaseService {

    public url2 = url;
    constructor(
        private http: HttpClient
        
        
        ) {

    }

    image64(url) {
        let headers = new HttpHeaders();
        let data = { 
            image: url
        };
        let body = JSON.stringify(data);
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.url2 + 'imageBase64.php', body, { headers } );

    }

 

}